export default {
    // 조회 기간
    // Example) betweenDate: [yyyy-mm-dd, yyyy-mm-dd],
    betweenDate: [],
    // 바로머니 리포트 v-data-table items
    tableItems: [],
};
